/* unplugin-vue-components disabled */import script from "./associationpage.vue?vue&type=script&setup=true&lang=ts"
export * from "./associationpage.vue?vue&type=script&setup=true&lang=ts"

import "./associationpage.vue?vue&type=style&index=0&id=4b6c438e&lang=less&scoped=true"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue - Copy (2)\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b6c438e"]])

export default __exports__